module.exports = __webpack_public_path__ + "static/media/logo-iviettech.a105c746.png";